module.exports = __webpack_public_path__ + "img/bth_bed_right_yaobu_sel.0e59b22f.png";